export const DEFAULT_HOST = 'https://api.bynn.com';

export const DEFAULT_TEXT = {
  loadingText: 'Loading...',
  submitBtnText: 'Start Verification'
};

export const STYLES = {
  form: 'bynn-form',
  input: 'bynn-input',
  inputWrapper: 'bynn-input-wrapper',
  label: 'bynn-label',
  submit: 'bynn-submit',
  description: 'bynn-description'
};
